import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useMenuRedirect from '../../Menu/hooks/useMenuRedirect';
import { getCmsInfo } from '../redux/actions/cms.actions';
import { selectMetadataKeyByRegion } from './../../../reducers/selectors/metadata';
import { getProfileLastTouchFavorited } from 'utils/Socialization';

//ESTE HOOK DISPARA LOS SERVICIOS DE CMS Y RETORNA DATOS DE CONFIGURACIÓN EXTRA
export const useGetCmsInfo = (userHash, code) => {
  const { nodesSelected, firstNode } = useMenuRedirect();
  const [isLoading, setIsLoading] = useState(true);
  const [isInfiniteList, setIsInfiniteList] = useState(false);
  const [layoutType, setLayoutType] = useState(null);
  //const userHash = useSelector(state => state.user.userhash);
  const layoutConfig = useSelector(
    selectMetadataKeyByRegion('layout_node_configuration'),
  );

  const navData = useSelector(state => state?.cvNavData?.navData);
  const userData = useSelector(state => state?.user);

  const dispatch = useDispatch();

  const getTypeLayout = () => {
    try {
      const jsonData = JSON?.parse(navData?.selected?.app_behaviour || '{}');
      return jsonData?.layout;
    } catch (error) {
      return null;
    }
  };

  useEffect(
    () => {
      const node = code || firstNode || nodesSelected;
      if(!JSON.parse(sessionStorage.getItem('hasFetchNav'))) return
      //Define el tipo de layout
      setLayoutType(getTypeLayout() || null);

      //Ejecuta los sevicios de cms
      dispatch(
        getCmsInfo({
          node,
          userHash,
          setIsLoading,
          setIsInfiniteList,
          isInfiniteList,
          layout: layoutType,
        }),
      );
    },
    [!!userHash, userData?.user_id,JSON.parse(sessionStorage.getItem('hasFetchNav'))],
  );

  return {
    isLoading,
    isInfiniteList,
    layoutType,
  };
};
